import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { NgClass, NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { StaticFilesEndpointPipe } from '@shared/pipes/static-files-endpoint.pipe';
import { LayoutService } from './layout-service';

export interface Tile {
	id: number;
	title: string;
	iconUrl?: string;
}

@Component({
	selector: 'tiles',
	templateUrl: './tiles.component.html',
	styleUrls: ['./tiles.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [NgIf, NgFor, NgClass, NgTemplateOutlet, StaticFilesEndpointPipe, TranslateModule],
	providers: [LayoutService]
})
export class TilesComponent {
	@Input() tiles: Tile[] = [];
	@Input() selectedTileId: number | null = null;
	@Input() isDisabled = false;

	@Input() baseColor = 'blue';
	@Input() tileTemplate: TemplateRef<Tile> | null = null;

	@Output() tileClicked = new EventEmitter<Tile>();

	constructor(private readonly layoutService: LayoutService) {}

	readonly tileGap: number = 16;

	get hasSelection(): boolean {
		return this.selectedTileId !== null && this.selectedTileId !== undefined;
	}

	isSelected(tile: Tile): boolean {
		return this.selectedTileId === tile.id;
	}

	onTileClick(tile: Tile): void {
		this.tileClicked.emit(tile);
	}

	trackByTileId(index: number, tile: Tile): string | number {
		return tile.id ?? index;
	}

	getTileColor(tile: Tile, index: number): string | undefined {
		const shade = this.layoutService.getTileShade(this.tiles.length, index);

		return shade ? `${this.baseColor}-${shade}` : this.baseColor;
	}

	getTileWidth(index: number): string {
		const rowSize = this.layoutService.getTileRowSize(this.tiles.length, index);

		return `calc(${100 / rowSize}% - ${((rowSize - 1) * this.tileGap) / rowSize}px)`;
	}
}
